import CryptoJS from "crypto-js";

/**
 * توليد order ID فريد ومستحيل التكرار
 * يستخدم timestamp + random number + crypto hash لضمان التفرد
 */
export const generateUniqueOrderId = (): number => {
  // الحصول على timestamp الحالي بالمللي ثانية
  const timestamp = Date.now();

  // توليد رقم عشوائي بين 1000 و 9999
  const randomPart = Math.floor(Math.random() * 9000) + 1000;

  // إضافة performance.now() للحصول على دقة أعلى
  const performanceTime = Math.floor(performance.now() * 1000) % 10000;

  // دمج جميع القيم معاً
  const combined = parseInt(`${timestamp}${randomPart}${performanceTime}`);

  // استخدام modulo لضمان أن النتيجة ضمن نطاق JavaScript Number
  // مع الحفاظ على التفرد قدر الإمكان
  const result = combined % Number.MAX_SAFE_INTEGER;

  // التأكد من أن النتيجة موجبة
  return Math.abs(result);
};

/**
 * توليد order ID فريد باستخدام crypto hash (أكثر أماناً)
 */
export const generateCryptoUniqueOrderId = (): number => {
  // الحصول على timestamp الحالي
  const timestamp = Date.now().toString();

  // توليد رقم عشوائي
  const randomPart = Math.random().toString();

  // إضافة performance.now() للحصول على دقة أعلى
  const performanceTime = performance.now().toString();

  // دمج جميع القيم
  const combined = `${timestamp}_${randomPart}_${performanceTime}`;

  // إنشاء hash باستخدام SHA-256
  const hash = CryptoJS.SHA256(combined).toString();

  // تحويل أول 12 حرف من الـ hash إلى رقم
  const numericHash = parseInt(hash.substring(0, 12), 16);

  // التأكد من أن النتيجة ضمن نطاق JavaScript Number
  return Math.abs(numericHash % Number.MAX_SAFE_INTEGER);
};

/**
 * توليد order ID فريد مع prefix
 * مفيد للتمييز بين أنواع مختلفة من الطلبات
 */
export const generateUniqueOrderIdWithPrefix = (
  prefix: string = "ORDER"
): string => {
  const uniqueId = generateUniqueOrderId();
  return `${prefix}_${uniqueId}`;
};

/**
 * التحقق من أن order ID فريد (للتحقق من عدم التكرار)
 */
export const isUniqueOrderId = (id: number): boolean => {
  // يمكن إضافة منطق إضافي هنا للتحقق من قاعدة البيانات
  // حالياً نعتبر أن جميع الـ IDs فريدة
  return id > 0 && id <= Number.MAX_SAFE_INTEGER;
};
